<template>
  <div>
  <div>
    <div style="text-align:left; width: 600px; display: flex; margin-bottom: 10px;">
      <multiselect @input="refresh()" v-model="selectedBrand" :options="brands" multiple="true"  placeholder="Selecteer een merk" selected-label="✔" select-label="" deselect-label="✔" style="margin-right: 10px" />
      <multiselect @input="refresh()" v-model="selectedMarketplace" :options="marketplaces" multiple="true"  placeholder="Selecteer een marktplaats" selected-label="✔" select-label="" deselect-label="✔" style="margin-right: 10px" />
      
        <!-- <label for="minProfitMargin" class="form-label"> min: {{minProfitMargin}}</label> 
        <input v-model="minProfitMargin" type="range" class="form-range" id="minProfitMargin"  @change="refresh()">
        <label for="maxProfitMargin" class="form-label"> max: {{maxProfitMargin}}</label>
        <input v-model="maxProfitMargin" type="range" class="form-range" id="maxProfitMargin"  @change="refresh()"> -->

      </div>
    </div>
    <api-table-block ref="productsTable" :fields="fields" :items="findAllProducts" default-sort-by="profit_margin" item-label-singular="product" item-label-plural="producten">
      <template slot="before-block-content">
        <div class="block-content">
          <div class="pull-right">
             <label class="css-control css-control-sm css-control-primary css-switch ">
              <input type="checkbox" class="css-control-input" v-model="showPricesInclVat" @change="refresh">
              <span class="css-control-indicator"></span> Incl btw
            </label>

            <label class="css-control css-control-sm css-control-primary css-switch">
              <input type="checkbox" class="css-control-input" v-model="showPricesExclVat" @change="refresh">
              <span class="css-control-indicator"></span> Excl btw
            </label>
          </div>    
        </div>
      </template>
      <template slot="name" slot-scope="data">
        <a href="#" @click.prevent="details(data.item)">{{data.value}}</a>
      </template>
      <template slot="marketplace" slot-scope="data">
        {{data.value}}
      </template>
      <template slot="purchase_price" slot-scope="data">
        <span v-if="showPricesInclVat">{{ Math.round((data.value * 1.21) * 100) / 100  }}</span>
        <span v-else>{{data.value}}</span>
      </template>
      <template slot="price" slot-scope="data">
        <span v-if="showPricesExclVat">{{ Math.round((data.value / 1.21 ) * 100) / 100 }}</span>
        <span v-else>{{data.value}}</span>
      </template>
      <template slot="profit_margin" slot-scope="data">
        <b v-if="data.value >= 30" class="text-success">{{data.value + '%'}}</b>
        <b v-if="data.value < 30 && data.value >= 0" class="text-warning">{{data.value + '%'}}</b>
        <b v-if="data.value < 0" class="text-danger">{{data.value + '%'}}</b>
      </template>
    </api-table-block>

  </div>
</template>

<script>
import http from '../utils/http'
import ApiTableBlock from '../common/ApiTableBlock'

export default {
  components: {
    ApiTableBlock
  },
  data () {
    return {
      fields: {
        name: {
          label: 'Product',
          thStyle: 'width: 40%;',
          sortable: false
        },
        marketplace: {
          label: 'Marketplace',
          thStyle: 'width: 15%;',
          sortable: true
        },
        purchase_price: {
          label: 'Inkoopprijs',
          thStyle: 'width: 15%;',
          sortable: true
        },
        price: {
          label: 'Verkoopprijs',
          thStyle: 'width: 15%;',
          sortable: true
        },
        profit_margin: {
          label: 'Winst marge',
          thStyle: 'width: 15%;',
          sortable: true
        }
      },
      minProfitMargin: 0,
      maxProfitMargin: 10000,
      selectedBrand: null,
      selectedMarketplace: null,
      showPricesInclVat: false,
      showPricesExclVat: false,
      brands: [],
      marketplaces: []
    }
  },
  methods: {
    findAllProducts (params) {
      params['include'] = 'product'
      if (this.selectedBrand) {
        params['filter[product.brand]'] = this.selectedBrand
      }
      if (this.selectedMarketplace) {
        params['filter[marketplace]'] = this.selectedMarketplace
      }
      if (this.minProfitMargin) {
        params['filter[min_profit_margin]'] = this.minProfitMargin
      }
      if (this.maxProfitMargin) {
        params['filter[max_profit_margin]'] = this.maxProfitMargin
      }
      return http.get('/products-marketplaces-prices', { params })
    },
    refresh () {
      this.$refs.productsTable.refresh()
    },
    loadBrands () {
      http.get('brands')
      .then((result) => {
        this.brands = result.data.data
      })
    },
    loadMarketplaces () {
      http.get('products-marketplaces')
      .then((result) => {
        this.marketplaces = result.data.data
      })
    }
  },
  created () {
    this.loadBrands()
    this.loadMarketplaces()
  }
}
</script>



// WEBPACK FOOTER //
// ReportProfitMarginPage.vue?008420b9